import { render, staticRenderFns } from "./FirstDayOfWeekSection.vue?vue&type=template&id=c96fdb60&scoped=true"
import script from "./FirstDayOfWeekSection.vue?vue&type=script&lang=ts"
export * from "./FirstDayOfWeekSection.vue?vue&type=script&lang=ts"
import style0 from "./FirstDayOfWeekSection.vue?vue&type=style&index=0&id=c96fdb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96fdb60",
  null
  
)

export default component.exports